// 色の定数
const COLORS = {
  // プライマリー色
  primary: '#007bff',
  primaryDark: '#0056b3',
  
  // グレー系
  gray100: '#f8f9fa',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray600: '#6c757d',
  gray800: '#495057',
  gray900: '#212529',
  
  // 状態色
  warning: '#856404',
  warningBg: '#fff3cd',
  warningBorder: '#ffeaa7',
  
  danger: '#721c24',
  dangerBg: '#f8d7da',
  dangerBorder: '#f5c6cb',
  
  info: '#0c5460',
  infoBg: '#d1ecf1',
  infoBorder: '#bee5eb',
  
  success: '#155724',
  successBg: '#d4edda',
  
  error: '#dc3545',
  errorBg: '#f8d7da',
  errorBorder: '#f5c6cb',
  
  // テキスト色
  textPrimary: '#333',
  textSecondary: '#6c757d',
  
  // 背景色
  white: '#ffffff',
};

/**
 * 基本スタイルオブジェクト
 */
const styles = {
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  header: {
    marginBottom: '20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.6',
  },
  notice: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '4px',
    padding: '15px',
    marginBottom: '30px',
    textAlign: 'center',
    color: '#856404',
  },
  documentSection: {
    marginBottom: '40px',
  },
  documentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    padding: '10px',
    borderRadius: '4px',
  },
  documentTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
    margin: 0,
    textAlign: 'left',
  },
  checkMark: {
    color: '#28a745',
    fontSize: '20px',
  },
  scrollHint: {
    fontSize: '14px',
    color: '#dc3545',
    fontWeight: 'bold',
  },
  scrollContainer: {
    height: '400px',
    overflowY: 'auto',
    border: '2px solid #dee2e6',
    borderRadius: '8px',
    padding: '30px',
    backgroundColor: '#fff',
    marginBottom: '10px',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
    textAlign: 'left',
  },
  pdfScrollContainer: {
  height: '400px',
  overflowY: 'auto',
  border: '2px solid #dee2e6',
  borderRadius: '8px',
  padding: '30px',
  backgroundColor: '#fff',
  marginBottom: '10px',
  boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
},
  content: {
    lineHeight: '1.8',
  },
  section: {
    marginBottom: '40px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#007bff',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #007bff',
  },
  revisionDate: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '15px',
    fontStyle: 'italic',
  },
  article: {
    marginBottom: '25px',
  },
  articleTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#495057',
    marginBottom: '10px',
  },
  articleText: {
    fontSize: '14px',
    color: '#333',
    marginBottom: '10px',
    lineHeight: '1.8',
  },
  list: {
    paddingLeft: '20px',
    marginTop: '10px',
  },
  agreementSection: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '2px solid #dee2e6',
  },
  agreementText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
  },
  scrollStatus: {
    textAlign: 'center',
    padding: '10px',
    minHeight: '40px',
  },
  scrollComplete: {
    color: '#28a745',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  scrollIncomplete: {
    color: '#dc3545',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  overallStatus: {
    marginTop: '30px',
    marginBottom: '20px',
  },
  allCompleteBox: {
    backgroundColor: '#d4edda',
    border: '2px solid #28a745',
    borderRadius: '8px',
    padding: '20px',
    textAlign: 'center',
  },
  allCompleteText: {
    color: '#155724',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  incompleteBox: {
    backgroundColor: '#f8d7da',
    border: '2px solid #dc3545',
    borderRadius: '8px',
    padding: '20px',
    textAlign: 'center',
  },
  incompleteText: {
    color: '#721c24',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  buttonContainer: {
    textAlign: 'center',
    marginTop: '20px',
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '15px 40px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '200px',
  },
  buttonDisabled: {
    backgroundColor: '#6c757d',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  openTabButton: {
    padding: '10px 16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
    flexShrink: 0,
  },

  // ===== ズームコントロール関連のスタイル =====
  zoomControl: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
    padding: '8px',
    borderRadius: '4px',
  },
  zoomButton: {
    padding: '6px 12px',
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
  },
  zoomButtonHover: {
    backgroundColor: COLORS.primaryDark,
  },
  zoomButtonDisabled: {
    backgroundColor: COLORS.gray600,
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  zoomResetButton: {
    padding: '6px 12px',
    backgroundColor: COLORS.gray600,
    color: COLORS.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
  },
  zoomResetButtonHover: {
    backgroundColor: '#5a6268',
  },
  zoomLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
    minWidth: '60px',
    textAlign: 'center',
    color: COLORS.textPrimary,
  },
  
  // ===== PDF表示関連のスタイル =====
  pdfLoading: {
    textAlign: 'center',
    padding: '40px',
    color: COLORS.textSecondary,
    fontSize: '14px',
  },
  pdfError: {
    textAlign: 'center',
    padding: '40px',
    color: COLORS.error,
    fontSize: '14px',
  },
  
  // ===== ローディング・エラー画面のスタイル =====
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
    fontSize: '16px',
    color: COLORS.textSecondary,
  },
  errorContainer: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '30px',
    textAlign: 'center',
    backgroundColor: COLORS.errorBg,
    border: `2px solid ${COLORS.errorBorder}`,
    borderRadius: '8px',
  },
  errorTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: COLORS.danger,
    marginBottom: '15px',
  },
  errorMessage: {
    fontSize: '14px',
    color: COLORS.textPrimary,
    marginBottom: '20px',
    lineHeight: '1.6',
  },
  retryButton: {
    padding: '10px 20px',
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
  },

  // ===== セクションサブタイトルのスタイル =====
  termsSubtitle: {
    fontSize: '14px',
    fontWeight: 'normal',
    display: 'block',
    textAlign: 'left',
    marginTop: '8px',
    color: '#666',
  },

  // ===== 同意チェックボックス関連のスタイル =====
  agreementCheckboxContainer: {
    marginTop: '30px',
    padding: '20px',
    backgroundColor: COLORS.gray100,
    borderRadius: '8px',
    border: `2px solid ${COLORS.gray300}`,
  },
  agreementCheckboxLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  agreementCheckboxLabelEnabled: {
    cursor: 'pointer',
    color: COLORS.gray900,
  },
  agreementCheckboxLabelDisabled: {
    cursor: 'not-allowed',
    color: COLORS.gray600,
  },
  agreementCheckbox: {
    width: '20px',
    height: '20px',
    marginRight: '12px',
  },
  agreementCheckboxEnabled: {
    cursor: 'pointer',
  },
  agreementCheckboxDisabled: {
    cursor: 'not-allowed',
  },
  agreementCheckboxHint: {
    marginTop: '10px',
    fontSize: '13px',
    color: COLORS.error,
    marginLeft: '32px',
  },
};

export { styles, COLORS };